export const AUTH_CONTEXT_PREFIX = '[Auth Context]';
export const AUTH_CONTEXT_FEATURE_SELECTOR = 'AuthContext'

export const TENANT_PREFIX = '[Tenant]';
export const TENANT_FEATURE_SELECTOR = 'Tenant'

export const SPACE_PREFIX = '[Space]';
export const SPACE_FEATURE_SELECTOR = 'Space'

export const CONVERSATIONAL_PREFIX = '[Conversational]';
export const CONVERSATIONAL_FEATURE_SELECTOR = 'Conversational'

export const META_PREFIX = '[Meta]';
